module.exports = __webpack_public_path__ + "static/1329782829.5bfc9bdd.jpg";